import { render } from "./SwdWIPBlock.vue?vue&type=template&id=59d30f58"
import script from "./SwdWIPBlock.vue?vue&type=script&lang=js"
export * from "./SwdWIPBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__